/* "Doplň do dopravy zdarma": while the cart is between data-min and the free-shipping threshold, offers up to 3 products from the
   top-up collection that are priced at least the missing amount (cheapest first). Cart page reloads after adding, the drawer re-renders. */
class KiidsTopup extends HTMLElement {
  static pool;

  static loadPool(handle) {
    KiidsTopup.pool ??= fetch(`/collections/${handle}/products.json?limit=250`)
      .then((r) => (r.ok ? r.json() : { products: [] }))
      .then(({ products }) => products
        .map((p) => {
          const open = p.variants.filter((v) => v.available);
          return open.length && p.images[0] ? { id: p.id, title: p.title, handle: p.handle, img: p.images[0].src, price: Math.min(...open.map((v) => +v.price)), variant: p.variants.length === 1 ? open[0].id : null } : null;
        })
        .filter(Boolean)
        .sort((a, b) => a.price - b.price))
      .catch(() => []);
    return KiidsTopup.pool;
  }

  connectedCallback() {
    this.run = 0;
    this.onCartUpdated = () => this.render();
    document.addEventListener('cart:updated', this.onCartUpdated);
    this.unsubscribe = typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' ? subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdated) : null;
    this.addEventListener('click', (e) => this.onAdd(e));
    this.render().finally(() => this.removeAttribute('data-reserve')); // the server-reserved band height is released once the strip is decided
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.onCartUpdated);
    this.unsubscribe?.();
  }

  async render() {
    const run = ++this.run;
    const limit = Number(window.free_shipping_price) * 100;
    const cart = await fetch('/cart.js').then((r) => r.json());
    const missing = limit - cart.total_price;
    if (run !== this.run) return;
    if (!limit || cart.total_price < Number(this.dataset.min) * 100 || missing <= 0) return void (this.hidden = true);
    const inCart = new Set(cart.items.map((i) => i.product_id));
    const pool = await KiidsTopup.loadPool(this.dataset.collection);
    if (run !== this.run) return;
    const picks = pool.filter((p) => p.price * 100 >= missing && !inCart.has(p.id)).slice(0, 3);
    if (!picks.length) return void (this.hidden = true);
    const money = (v) => Shopify.formatMoney(Math.round(v * 100), window.money_format);
    const esc = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
    this.innerHTML = `<p class="kiids-topup__title">${esc(this.dataset.title)}</p><ul class="kiids-topup__list">${picks.map((p) => `
      <li class="kiids-topup__item"><a class="kiids-topup__media" href="/products/${p.handle}"><img src="${p.img}${p.img.includes('?') ? '&' : '?'}width=240" alt="" width="120" height="120" loading="lazy"></a>
        <a class="kiids-topup__name" href="/products/${p.handle}">${esc(p.title)}</a><span class="kiids-topup__price">${money(p.price)}</span>
        ${p.variant ? `<button type="button" class="kiids-topup__add" data-variant="${p.variant}">${esc(this.dataset.add)}</button>` : `<a class="kiids-topup__add" href="/products/${p.handle}">${esc(this.dataset.view)}</a>`}</li>`).join('')}</ul>`;
    this.hidden = false;
  }

  async onAdd(e) {
    const btn = e.target.closest('button[data-variant]');
    if (!btn) return;
    btn.disabled = true;
    const drawer = this.closest('cart-drawer');
    const body = { id: Number(btn.dataset.variant), quantity: 1 };
    if (drawer?.renderContents) Object.assign(body, { sections: drawer.getSectionsToRender().map((s) => s.id).join(','), sections_url: window.location.pathname });
    try {
      const res = await fetch(window.routes?.cart_add_url || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const data = await res.json();
      if (data.status) return void (btn.disabled = false);
      if (drawer?.renderContents) {
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kiids-topup', cartData: data });
        drawer.renderContents(data);
      } else {
        location.reload();
      }
    } catch {
      btn.disabled = false;
    }
  }
}
customElements.define('kiids-topup', KiidsTopup);
